import React from "react";
import { Select } from "antd";
const { Option } = Select;

interface ArithmeticOperatorSelectProps {
  value: string;
  onChange: (value: string) => void;
  className?: string;
}

export const ArithmeticOperatorSelect: React.FC<ArithmeticOperatorSelectProps> = ({
  value,
  onChange,
  className
}) => {
  const arithmeticOperators = [
    {
      operator: "+",
      label: "Addition (+)"
    },
    {
      operator: "-",
      label: "Subtraction (-)"
    },
    {
      operator: "*",
      label: "Multiplication (*)"
    },
    {
      operator: "/",
      label: "Division (/)"
    }
  ];

  return (
    <Select
      value={value}
      onChange={onChange}
      className={className}
      style={{ width: '120px' }}
    >
      {arithmeticOperators.map(op => (
        <Option key={op.operator} value={op.operator}>
          {op.label}
        </Option>
      ))}
    </Select>
  );
}; 